import styled from "styled-components";
import { thumbStyles } from "./thumbStyles";
import isPropValid from "@emotion/is-prop-valid";
export const ThumbY = styled.div.withConfig({
    shouldForwardProp: isPropValid,
}) `
  width: 100%;
  ${thumbStyles}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGh1bWJZLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2Nyb2xsYmFyL3N0eWxlZC9UaHVtYlkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUM1QyxPQUFPLFdBQVcsTUFBTSx3QkFBd0IsQ0FBQztBQUVqRCxNQUFNLENBQUMsTUFBTSxNQUFNLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUM7SUFDMUMsaUJBQWlCLEVBQUUsV0FBVztDQUMvQixDQUFDLENBQUE7O0lBRUUsV0FBVztDQUNkLENBQUMifQ==